var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "wikiContents",
    attrs: {
      "data-editor-active": "",
      "data-depth": _vm.depth,
      "data-parent-type": _vm.parentType
    }
  }, [_vm.editor.step == 0 ? _c('div', {
    staticClass: "contentStep1"
  }, [_c('h1', {
    ref: "title",
    staticClass: "title",
    attrs: {
      "data-title": _vm.editor.key
    }
  }, [_vm._v(" " + _vm._s(`${_vm.editor.title || _vm.editor.text}`) + " ")]), _c('div', {
    staticClass: "contents",
    domProps: {
      "innerHTML": _vm._s(_vm.editor.content)
    }
  })]) : _vm._e(), _vm.editor.step == 1 ? _c('div', {
    staticClass: "contentStep2"
  }, [_c('h2', [_vm._v(_vm._s(`${_vm.editor.title || _vm.editor.text}`))]), _c('div', {
    staticClass: "contentWrap"
  }, [_c('div', {
    staticClass: "contents",
    domProps: {
      "innerHTML": _vm._s(_vm.editor.content)
    }
  }), _c('div', {
    staticClass: "contentStep3"
  }, _vm._l(_vm.editor.child, function (child, index) {
    return _vm.editor.child ? _c('wikiContent', {
      attrs: {
        "editor": child,
        "depth": _vm.depth + 1,
        "position": _vm.positionSet,
        "index": index,
        "parentType": _vm.getParentType
      }
    }) : _vm._e();
  }), 1)])]) : _vm._e(), _vm.editor.step >= 2 ? _c('div', {
    staticClass: "contentStep3"
  }, [_c('h3', [_vm._v(_vm._s(_vm.editor.title))]), _c('div', {
    staticClass: "contents",
    domProps: {
      "innerHTML": _vm._s(_vm.editor.content)
    }
  }), _vm._l(_vm.editor.child, function (child, index) {
    return _vm.editor.child ? _c('wikiContent', {
      attrs: {
        "editor": child,
        "depth": _vm.depth + 1,
        "position": _vm.positionSet,
        "index": index,
        "parentType": _vm.getParentType
      }
    }) : _vm._e();
  })], 2) : _vm._e(), _vm._l(_vm.editor.child, function (child, index) {
    return _vm.editor.step <= 0 && _vm.editor.child ? _c('wikiContent', {
      attrs: {
        "editor": child,
        "depth": _vm.depth + 1,
        "position": _vm.positionSet,
        "index": index,
        "parentType": _vm.getParentType
      }
    }) : _vm._e();
  })], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }